import React, { Fragment } from 'react';
import {
  Datagrid,
  FunctionField,
  NumberField,
  ReferenceManyField,
  useRefresh,
  TextField,
} from 'react-admin';
import CreateButton from 'Resources/PlotSuspect/QuickCreate';
import EditButton from 'Resources/PlotSuspect/QuickEdit';
import { Pagination } from 'Components';
import { tabbedLists } from 'styles';

const SuspectsTab = (props) => {
  const classes = tabbedLists();
  const refresh = useRefresh();
  const { record } = props;

  // re
  return (
    <Fragment>
      <div className={classes.actions}>
        <CreateButton record={record} onChange={() => refresh()} />
      </div>
      <ReferenceManyField
        reference="plotSuspect"
        target="plotId"
        source="id"
        sort={{ field: 'priorityNumber', order: 'ASC' }}
        pagination={<Pagination />}
        perPage={50}
      >
        <Datagrid>
          <TextField source="name" sortable={false} />
          <NumberField source="priorityNumber" sortable={false} />
          <NumberField source="requiredActors" sortable={false} />
          <FunctionField render={(record) => <EditButton record={record} />} />
        </Datagrid>
      </ReferenceManyField>
    </Fragment>
  );
};

export default SuspectsTab;
